// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['el_GR']  = {
  "name": "el_GR",
  "day": {
    "abbrev": [
      "Κυρ",
      "Δευ",
      "Τρι",
      "Τετ",
      "Πεμ",
      "Παρ",
      "Σαβ"
    ],
    "full": [
      "Κυριακή",
      "Δευτέρα",
      "Τρίτη",
      "Τετάρτη",
      "Πέμπτη",
      "Παρασκευή",
      "Σάββατο"
    ]
  },
  "month": {
    "abbrev": [
      "Ιαν",
      "Φεβ",
      "Μάρ",
      "Απρ",
      "Μάι",
      "Ιούν",
      "Ιούλ",
      "Αύγ",
      "Σεπ",
      "Οκτ",
      "Νοέ",
      "Δεκ"
    ],
    "full": [
      "Ιανουάριος",
      "Φεβρουάριος",
      "Μάρτιος",
      "Απρίλιος",
      "Μάιος",
      "Ιούνιος",
      "Ιούλιος",
      "Αύγουστος",
      "Σεπτέμβριος",
      "Οκτώβριος",
      "Νοέμβριος",
      "Δεκέμβριος"
    ]
  },
  "meridiem": [
    "πμ",
    "μμ"
  ],
  "date": "%d/%m/%Y",
  "time24": "%r",
  "dateTime": "%a %d %b %Y %r %Z",
  "time12": "%I:%M:%S %p",
  "full": "%a %d %b %Y %r %Z"
}

